'use client'

import ArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import { PageWithHeader } from 'app/(auth)/_components'
import { NextPage } from 'next'
import { useCallback, useContext } from 'react'
import { PageTypeProvider } from '~/features/profile/components/Withdrawal/PageTypeProvider'
import { WithdrawalPageTypeContext } from '~/features/profile/components/Withdrawal/PageTypeProvider/context'
import { WithdrawalPageContent } from '~/features/profile/pageComponents/withdrawal'

const WithdrawalPage: NextPage<{}> = () => {
  const { isVisiblePageBack, pageType, updatePageType } = useContext(WithdrawalPageTypeContext)

  const handlePageBack = useCallback(() => {
    if (pageType === 'select_reason') {
      return updatePageType('begin')
    } else if (pageType === 'confirm') {
      return updatePageType('select_reason')
    }
    return
  }, [pageType, updatePageType])

  return (
    <PageWithHeader
      titleI18nKey='withdrawal'
      mobileLeftContent={
        isVisiblePageBack && (
          <ArrowLeft onClick={handlePageBack} sx={{ color: 'white', cursor: 'pointer' }} />
        )
      }
    >
      <WithdrawalPageContent
        pageType={pageType}
        updatePageType={updatePageType}
        onClickPageBack={isVisiblePageBack ? handlePageBack : undefined}
      />
    </PageWithHeader>
  )
}

const wrapper = () => {
  return (
    <PageTypeProvider>
      <WithdrawalPage />
    </PageTypeProvider>
  )
}

export default wrapper
